import Vue from 'vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import AccordionOptions from './components/_edit-options';
import AccordionSection from './components/section';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('accordion', {
  template: require('./template.html'),
  mixins: [guid, cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'bouncePluginHook',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.globalBubbleOptionsOpen ||
      this.globalToolBarOpen ||
      this.dragging ||
      (this.globalBubbleOpen && !this.showEditBubble);
    },
    getTransformStyle() {
      let style = null;
      if (this.globalToolBarOpen) {
        style = 'initial';
      }
      if (!this.globalBubbleOpen && this.display.perspective) {
        style = 'preserve-3d';
      }
      return style;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzAccordion' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    lastRowMargin() {
      const selector = _.find(this.droplet.mediaQueries, {
        selector: dropletSchema.lastRowSelector,
      });
      const property = selector ? _.find(selector.properties, { property: 'margin-bottom' }) : false;
      return property;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        tabPaddingTop: null,
        tabPaddingBottom: null,
        tabPaddingLeft: null,
        tabPaddingRight: null,
        'padding-left': null,
        'padding-right: ': null,
        'padding-top:': null,
        'padding-bottom': null,
        'border-top-left-radius': null,
        'border-top-right-radius': null,
        'border-bottom-left-radius': null,
        'border-bottom-right-radius': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'margin-bottom': null,
        'box-shadow': null,
      },
      dropletHovered: false,
      hasActiveChild: false,
      showEditBubble: false,
      setBubbleSize: 'dropletBubble-normal',
      openToolBar: false,
      hidden: false,
      showRevealClass: false,
    };
  },
  name: 'accordion',
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    AccordionOptions,
    AccordionSection,
    tooltip,
  },
  created() {
    this.checkNewValues();
  },
  mounted() {
    this.callCssGenerator();
    $(document).ready(this.bindPlugin);
    this.observeVisibility();
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    'activeDroplet._id': function checkDroplets(id) {
      if (id && this.droplet._id !== id) {
        const activeDroplets = this.$el.querySelectorAll(`#drp-${id}`);
        if (activeDroplets.length > 0) {
          this.hasActiveChild = true;
        }
      } else {
        this.hasActiveChild = false;
      }
      if (!id) {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzAccordion',
        });
      }
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    bouncePluginHook(id) {
      if (this.droplet._id === id) {
        this.unBindPlugin();
        this.bindPlugin();
        this.$store.dispatch('callPluginBounce', false);
      }
    },
    'droplet.search': function search() {
      this.unBindPlugin();
      this.bindPlugin();
    },
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    checkNewValues() {
      if (!this.lastRowMargin) {
        this.$store.dispatch('changeDropletCss', {
          drp: this.droplet,
          val: '0px',
          property: 'margin-bottom',
          selector: dropletSchema.lastRowSelector,
          viewport: this.viewport,
        });
        this.callCssGenerator();
      }
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    handleToolbar(v) {
      this.openToolBar = v;
      this.showEditBubble = false;
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    bindPlugin() {
      const $accordion = $(this.$refs.drzAccordion);
      $accordion.drzAccordion({
        search: this.droplet.search,
      });
    },
    unBindPlugin() {
      const $accordion = $(this.$refs.drzAccordion);
      $accordion.drzAccordion.killEvents($accordion);
    },
    toggleBubble() {
      if (!this.roamingTemplate && !this.openToolBar) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/accordion/index.js